import React from 'react';
import PropTypes from 'prop-types';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import AgencyTransactionListScreen from './screens/AgencyTransactionListScreen';

ManageAgencyTransaction.propTypes = {};

function ManageAgencyTransaction(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-4 pb-4 mt-4">
                <Routes>
                    <Route path="" element={<AgencyTransactionListScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default ManageAgencyTransaction;
